export type DateInterval = "year" | "quarter" | "month" | "week" | "day" | "hour" | "minute" | "second";

export function fixUrlTrailingSlash(url: string): string {
    url = url.trim();
    if (url.length === 0 || url[url.length-1] === "/")
        return url;
    return url + "/";
}

/**
 * Adds the given units of interval to the date.
 * It returns a copy of the date, so the given date is not modified.
 * @param date
 * @param interval
 * @param units
 */
export function dateAdd(date: Date, interval: DateInterval, units: number): Date {
    let ret = new Date(date); //don't change original date
    switch (interval.toLowerCase()) {
        case 'year'   :  ret.setFullYear(ret.getFullYear() + units);  	break;
        case 'quarter':  ret.setMonth(ret.getMonth() + 3*units);  		break;
        case 'month'  :  ret.setMonth(ret.getMonth() + units);  		    break;
        case 'week'   :  ret.setDate(ret.getDate() + 7*units);  		        break;
        case 'day'    :  ret.setDate(ret.getDate() + units);  			        break;
        case 'hour'   :  ret.setTime(ret.getTime() + units*3600000);  	        break;
        case 'minute' :  ret.setTime(ret.getTime() + units*60000);  	        break;
        case 'second' :  ret.setTime(ret.getTime() + units*1000);  		        break;
        default       :  ret = undefined;  break;
    }
    return ret;
}

export function assertUnreachableCode(x: never): never {
    throw new Error("Unexpected object: " + x);
}

export function toDisplayTimeHHMMSS(secondsTotal: number, forceHours: boolean = false): string {
    const hours = Math.floor(secondsTotal / 3600);
    const minutes = Math.floor((secondsTotal - (hours * 3600)) / 60);
    const seconds = secondsTotal - (hours * 3600) - (minutes * 60);

    let timeStr = "";
    if (hours !== 0 || forceHours === true) {
        if (hours < 10)
            timeStr += "0";
        timeStr += hours + ":";
    }
    if (minutes < 10)
        timeStr += "0";
    timeStr += minutes + ":";
    if (seconds < 10)
        timeStr += "0";
    timeStr += seconds;
    return timeStr;
}
